/**
 * File forms.js.
 *
 * Swaps visual states of form sections
 * Used on: Protocols Adherence Form & Membership Application Pages
 */

(function( $ ) {
		$( document ).ready( function() {
			'use strict';

			//removes no-js class w/ JS which is used in browsers where JS is disabled
			$( 'body' ).removeClass( 'no-js' );

			//@todo: Move to a different file & write cleaner - this is for the membership page, not form
			$( '.member-collap-title' ).click( triggerCollapseButton );

			//needed for functions that clone sets of fields
			var cloneId = 0;

			//edit offset to error anchors from validator
			$.fn.validator.Constructor.FOCUS_OFFSET = 200;

			$( '.btn-section-toggle' ).click( updateToggleSectionBtn );
			$( '.form-step-title' ).click( triggerCollapseButton );

			$( 'body' ).on( 'change', 'select.country', function( event ) {
				let regionElement = $( event.target ).attr( 'data-regionElement' ),
					regionElementSelector = $( `#${regionElement}` ),
					regionElementFormGroup = regionElementSelector.closest( '.form-group' ),
					helpBlock = regionElementSelector.siblings( '.help-block.with-errors' ),
					countryVal = event.target.value;

				//if US is chosen, add required
				if ( countryVal === 'US' ) {
					regionElementSelector.attr( 'required', 'required' );
					regionElementFormGroup.addClass( 'has-error has-danger' );
					helpBlock.text( 'State required when country is U.S.' );
				} else {
					regionElementSelector.removeAttr( 'required', 'required' );
					regionElementFormGroup.removeClass( 'has-error has-danger' );
					helpBlock.text( '' );
				}

				//Is being used for shipping on book/onDemand checkout
				//@todo: Use function from iMIS API plugin to build country/state dropdowns, do not run on membership form
				if ( 'undefined' !== typeof regionElement && ! $( 'body' ).hasClass('page-template-page-membership') ) {
					let url = `${wpApiSettings.root}isda/v1/country?name=${event.target.value}`;
					regionElementSelector.empty()
					                     .append( '<option disabled="disabled" selected>Select</option>' );
					$.get( url, function( response ) {
						if ( response.length ) {
							regionElementSelector
								.append( buildOptions( response ) );
						} else {
							/* @todo: Better solution necessary
							 This is a temp solution to prevent fatal errors
							 from imis seeking a state for countries that don't have states.
							 We'll need a more elegant solution than this.
							 */
							regionElementSelector
								.append( '<option>Does Not Apply</option>' );
						}
					} );
				}

				//Used on membership form
				$.ajax( {
					type   : 'GET',
					url    : wpApiSettings.root + 'isda/v1/membership-get-states',
					data   : {
						country: countryVal
					},
					success: function( data ) {
						regionElementSelector.html( data['states'] );
					},
					error  : function( data ) {
						console.log( 'error ', data);
					}
				} );
			} );

			$( '#bookstore-checkout, #primary-members-form' )
				.validator()
				.on( 'submit', function( e ) {
					if ( !e.isDefaultPrevented() ) {
						$( '[type=submit]', this )
							.attr( 'disabled', 'disabled' )
							.addClass( 'disabled' );
						$( '[type=submit]', this )
							.html( ' <img class="spinner" src="' + ISDA_Main.ajaxLoader + '">' );
					}

				} );
		} ); // doc ready

		function disabled_conditional_fields_if_js_present( fieldList ) {
			//Will only disabled fields when not in "duplicate letter" mode
			if ( window.location.search.indexOf( 'duplicate=' ) < 1 ) {
				$.each( fieldList, function( index, value ) {
					let field        = $( '#' + value ),
					    condWrapperD = field.closest( '.conditional-section' );
					//only disable fields when not in "edit letter" mode
					if ( !field.hasClass( 'edit-mode-remove-disabled' ) && !condWrapperD.hasClass( 'enable-conditional-section' ) ) {
						field.attr( 'disabled', 'disabled' );
					}
				} );
			}
		}

		/**
		 * Trigger click on expand/collapse button in collapsibles
		 */
		function triggerCollapseButton() {
			$( this ).siblings( '.btn-section-toggle' ).trigger( 'click' );
		}

		/**
		 * @summary Previous button in membership app
		 *
		 * Opens next section by triggering a click on expand/collapse btn
		 * Closes any other open sections
		 */
		function previousCollapsibleBtn() {
			var thisFormStep = $( this ).parents( '.form-step' ),
			    prevFormStep = thisFormStep.prev();

			scrollToFormTop( prevFormStep );
			//if the previous section isn't already open
			if ( prevFormStep.hasClass( 'closed' ) ) {

				//trigger click on previous section's toggle button
				prevFormStep.find( '.btn-section-toggle' ).trigger( 'click' );
			}
		}

		/**
		 * @summary Next button in membership app
		 *
		 * Opens next section by triggering a click on expand/collapse btn
		 * Closes any other open sections
		 */
		function nextCollapsibleAppBtn() {
			var thisFormStep = $( this ).parents( '.form-step' ),
			    nextFormStep = thisFormStep.next();

			scrollToFormTop( nextFormStep );
			//if the next section isn't already open
			if ( nextFormStep.hasClass( 'closed' ) ) {
				//trigger click on next section's toggle button
				nextFormStep.find( '.btn-section-toggle' ).trigger( 'click' );
			}
		}

		/**
		 * Scroll to step when prev/next buttons are clicked
		 *
		 * @param selector
		 */
		function scrollToFormTop( formStep ) {
			if ( formStep ) {
				$( 'html, body' ).animate( {
					                           scrollTop: ($( formStep )
						                                       .offset().top - 100
					                           )
				                           }, 500 );
			}
		}

		/**
		 * Re-validate form if fields have changed attrs
		 * @param $form
		 */
		function updateFormValidation( form ) {
			//submit validation on checkbox change
			$( form ).validator( 'validate' );
		}

		/**
		 * @summary Update toggle button state & update step class
		 *
		 * Toggles glyphicons from plus to minus
		 * Updates aria-expanded attribute
		 * Toggles open/closed class on .form-step
		 */
		function updateToggleSectionBtn( e ) {
			var self = $( this ),
			    thisStep = self.parents( '.form-step' );

			e.preventDefault();

			if ( self.hasClass( 'glyphicon-plus' ) ) {
				self.removeClass( 'glyphicon-plus' )
				    .addClass( 'glyphicon-minus' );
				self.attr( 'aria-expanded', 'true' );
				thisStep.removeClass( 'closed' ).addClass( 'open' );
			} else {
				self.removeClass( 'glyphicon-minus' )
				    .addClass( 'glyphicon-plus' );
				self.attr( 'aria-expanded', 'false' );
				thisStep.removeClass( 'open' ).addClass( 'closed' );
			}
		}

		/**
		 * @summary Add class for section errors
		 *
		 * Checks if the default was prevented due to the validator,
		 * and adds a class to the section containing errors.
		 */
		function revealSectionErrors( e ) {
			var form       = $( this ),
			    errorGroup = form.find( '.form-group.has-error' ),
			    errorStep  = errorGroup.closest( '.form-step' ),
			    formSteps  = form.find( '.form-step' );

			errorStep.addClass( 'section-has-error' );

			//check each step for errored groups
			formSteps.each( function() {
				var step = $( this ), groups = step.find( '.form-group' );

				if ( false === groups.hasClass( 'has-error' ) ) {
					step.removeClass( 'section-has-error' );
				}
			} );

		}

		/**
		 * Modular function to add repeatable field sets
		 * @param cloneId
		 * @param containerId
		 */
		function addFormGroup( cloneId, containerId ) {
			var wrapper                          = $( '#' + containerId ),
			    groups                           = wrapper.find( '.repeatable-form-group' ),
			    lastGroup = groups.last(), clone = lastGroup.clone()
			                                                .attr( 'id', containerId + '-' + cloneId )
			                                                .appendTo( wrapper );

			//if/else membership addt contacts
			if ( containerId === 'additional-contacts-wrapper' ) {
				//create clone and pass it to below func to update attrs
				updateRepeatableFieldAttrsContacts( wrapper, cloneId, clone );
			} else {
				//create clone and pass it to below func to update attrs
				updateRepeatableFieldAttrs( wrapper, cloneId, clone );
			}
		}

		/**
		 * @summary Update ids/for attrs for cloned field sets
		 * @param wrapper
		 * @param cloneId
		 * @param clone
		 */
		function updateRepeatableFieldAttrs( wrapper, cloneId, clone ) {
			/**
			 * Note: Assume there are always only 2 text fields that get repeated with matching labels
			 * 1. save original's form group field ids and label attrs to use for clones
			 * 2. Find the first and second form groups in each clone
			 * 3. Find the text inputs and labels in each clone's form group
			 * 4. Update the ids/for attrs for clone text fields and labels using the original's
			 * as a base and appended with the cloneId increment.
			 */
			var origRepeatable    = wrapper.find( '.repeatable-form-group:first-of-type' ),
			    origFirstFieldId  = origRepeatable.find( '.form-group:nth-child(1) input' )
			                                      .attr( 'id' ),
			    origSecondFieldId = origRepeatable.find( '.form-group:nth-child(2) input' )
			                                      .attr( 'id' ), //find clone form groups
			    origThirdFieldId  = origRepeatable.find( '.form-group:nth-child(3) input' )
			                                      .attr( 'id' ), //find clone form groups
			    firstCloneGroup   = clone.find( '.form-group:nth-child(1)' ),
			    secondCloneGroup  = clone.find( '.form-group:nth-child(2)' ), //find remove btns from form groups
			    thirdCloneGroup   = clone.find( '.form-group:nth-child(3)' ), //find remove btns from form groups
			    cloneRemoveBtn    = clone.find( '.btn-remove-repeatable .sr-only' ), //find fields and labels in the 2 form groups for clones
			    firstCloneField   = firstCloneGroup.children( 'input' ),
			    firstCloneLabel   = firstCloneGroup.children( 'label' ),
			    firstCloneName    = incrementIndexInFieldArray( firstCloneField ),
			    secondCloneField  = secondCloneGroup.children( 'input' ),
			    secondCloneLabel  = secondCloneGroup.children( 'label' ),
			    secondCloneName   = incrementIndexInFieldArray( secondCloneField ),
			    thirdCloneField   = thirdCloneGroup.children( 'input' ),
			    thirdCloneLabel   = thirdCloneGroup.children( 'label' ),
			    thirdCloneName    = incrementIndexInFieldArray( thirdCloneField );

			//apply id and for attr to first field
			firstCloneField.attr( 'id', origFirstFieldId + '-' + cloneId )
			               .attr( 'name', firstCloneName ).val( '' );
			firstCloneLabel.attr( 'for', origFirstFieldId + '-' + cloneId );

			//apply id and for attr to second field
			secondCloneField.attr( 'id', origSecondFieldId + '-' + cloneId )
			                .attr( 'name', secondCloneName ).val( '' );
			secondCloneLabel.attr( 'for', origSecondFieldId + '-' + cloneId );

			//apply id and for attr to third field
			thirdCloneField.attr( 'id', origThirdFieldId + '-' + cloneId )
			               .attr( 'name', thirdCloneName ).val( '' );
			thirdCloneLabel.attr( 'for', origThirdFieldId + '-' + cloneId );

			//add id to screen reader text in remove buttons
			cloneRemoveBtn.find( '.sr-append' ).remove(); //clear existing appends
			$( '<span class="sr-append"> ' + cloneId + '</span>' )
				.appendTo( cloneRemoveBtn );
		}

		/**
		 * Does the same thing as the function above, except with more fields
		 * due to the additional contacts on membership
		 *
		 * @param wrapper
		 * @param cloneId
		 * @param clone
		 */
		function updateRepeatableFieldAttrsContacts( wrapper, cloneId, clone ) {
			//@todo: Refactor into a moer efficient function at some point but rn this works
			var original      = wrapper.children( '.single-contact:nth-child(1)' ),
			    region        = original.find( '.form-group:nth-of-type(1) .form-control' ),
			    prefix        = original.find( '.form-group:nth-of-type(2) .form-control' ),
			    fname         = original.find( '.form-group:nth-of-type(3) .form-control' ),
			    lname         = original.find( '.form-group:nth-of-type(4) .form-control' ),
			    suffix        = original.find( '.form-group:nth-of-type(5) .form-control' ),
			    title         = original.find( '.form-group:nth-of-type(6) .form-control' ),
			    email         = original.find( '.form-group:nth-of-type(7) .form-control' ),
			    phone         = original.find( '.form-group:nth-of-type(8) .form-control' ),
			    fax           = original.find( '.form-group:nth-of-type(9) .form-control' ),
			    address       = original.find( '.form-group:nth-of-type(10) .form-control' ),
			    city          = original.find( '.form-group:nth-of-type(11) .form-control' ),
			    country       = original.find( '.form-group:nth-of-type(12) .form-control' ),
			    state         = original.find( '.form-group:nth-of-type(13) .form-control' ),
			    zip           = original.find( '.form-group:nth-of-type(14) .form-control' ),
			    keyArray      = [
				    region, prefix, fname, lname, suffix, title, email, phone,
				    fax, address, city, country, state, zip
			    ],
			    regionClone   = clone.find( '.form-group:nth-of-type(1) .form-control' ),
			    prefixClone   = clone.find( '.form-group:nth-of-type(2) .form-control' ),
			    fnameClone    = clone.find( '.form-group:nth-of-type(3) .form-control' ),
			    lnameClone    = clone.find( '.form-group:nth-of-type(4) .form-control' ),
			    suffixClone   = clone.find( '.form-group:nth-of-type(5) .form-control' ),
			    titleClone    = clone.find( '.form-group:nth-of-type(6) .form-control' ),
			    emailClone    = clone.find( '.form-group:nth-of-type(7) .form-control' ),
			    phoneClone    = clone.find( '.form-group:nth-of-type(8) .form-control' ),
			    faxClone      = clone.find( '.form-group:nth-of-type(9) .form-control' ),
			    addressClone  = clone.find( '.form-group:nth-of-type(10) .form-control' ),
			    cityClone     = clone.find( '.form-group:nth-of-type(11) .form-control' ),
			    countryClone  = clone.find( '.form-group:nth-of-type(12) .form-control' ),
			    stateClone    = clone.find( '.form-group:nth-of-type(13) .form-control' ),
			    zipClone      = clone.find( '.form-group:nth-of-type(14) .form-control' ),
			    keyCloneArray = [
				    regionClone, prefixClone, fnameClone, lnameClone,
				    suffixClone, titleClone, emailClone, phoneClone, faxClone,
				    addressClone, cityClone, countryClone, stateClone, zipClone
			    ];

			$.each( keyCloneArray, function( index, value ) {
				var field            = $( this ),
				    existingNameAttr = incrementIndexInFieldArray( field ),
				    originalId       = keyArray[ index ].attr( 'id' ),
				    originalFor      = keyArray[ index ].siblings( '.control-label' )
				                                        .attr( 'for' );

				//empty clone fields
				field.val( '' );
				//add attributes/ids
				field.attr( 'id', originalId + '-' + cloneId );
				field.siblings( '.control-label' )
				     .attr( 'for', originalFor + '-' + cloneId );
				field.attr( 'name', existingNameAttr );
			} );
		}

		/**
		 * Increment "name" attrs for fields
		 * @param elem
		 */
		function incrementIndexInFieldArray( elem ) {
			if ( $( elem ).length && $( elem ).attr( 'name' ) ) {
				return $( elem ).attr( 'name' )
				                .replace( /\[(\d+)\]/, function( match, number ) {
					                // `number` refers to the first group (denoted with ())
					                return '[' + (+number + 1
					                ) + ']';
				                } );
			}

			return '';
		}

		/**
		 * Remove clone via trigger (close button) in the repeatable form group
		 * @param trigger
		 */
		function removeThisClone( trigger ) {
			var cloneWrapper = trigger.parents( '.repeatable-form-group' );

			cloneWrapper.find( 'input[required="required"]' )
			            .removeAttr( 'required', 'required' );

			updateFormValidation( '#protocols-adherence-letter-form' );

			cloneWrapper.remove();
		}

		function buildOptions( valuesForOptions ) {
			return valuesForOptions.map( value => {
				return `<option>${value}</option>`;
			} );
		}
	}
)( jQuery );
